import React, { useState, useEffect } from "react";
import { query, where, collection, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import QRCode from "../../components_root/QRCode.jsx";
import Bar_code from "../../components_root/bar_code.js";
import AmountToWords from "../../components_root/AmountToWords";
export default function Print_vouchers({ voucherprintid }) {
    const [voucherdata, setVoucherdata] = useState(null);
    const [voucheritemsdata, setVoucheritemsdata] = useState([]);
    const [companydata, setCompanydata] = useState(null);
    const [readyToPrint, setReadyToPrint] = useState(false);
       const servicetablename = "accountingfinancedb";
    // Fetch voucher
    useEffect(() => {
        const fetchVoucher = async () => {
            if (!voucherprintid) return;
            const select_company_uid = Cookies.get("select_company_uid");
            if (!select_company_uid) return;

            const q = query(
                collection(db, servicetablename, select_company_uid, "voucher_print"),
                where("voucherprintid", "==", voucherprintid)
            );
            const snap = await getDocs(q);
            const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
            setVoucherdata(data[0] || null);
        };
        fetchVoucher();
    }, [voucherprintid]);

    // Fetch correct company document
    useEffect(() => {
        const fetchCompanies = async () => {

            try {
                const q = query(
                    collection(db, servicetablename),
                    where("companyuid", "==", voucherdata.companyuid),
                );

                const snapshot = await getDocs(q);
                if (snapshot.empty) {
                    console.log("No companies found");
                    setCompanydata([]);
                    return;
                }
                const docs = await Promise.all(
                    snapshot.docs.map(async (docSnap) => {
                        const docData = docSnap.data();

                        // fetch child collection "fields"
                        const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                        let child = {};
                        fieldsSnap.forEach((fieldDoc) => {
                            const { fieldName, fieldValue } = fieldDoc.data();
                            child[fieldName] = fieldValue;
                        });

                        const fullData = { uid: docSnap.id, ...docData, child };

                        return fullData;
                    })
                );

                setCompanydata(docs); // update state

            } catch (err) {
                console.error("Error fetching companies:", err);
            } finally {
                setCompanydata([]);
            }
        };

        fetchCompanies();
    }, [voucherprintid, voucherdata]);


    useEffect(() => {
        if (readyToPrint == true && voucherdata) {
            printNow();
        }
    }, [readyToPrint, voucherdata]);
    // Auto print after voucher loads
    // <title>Receipt-${voucherprintid}</title>


    const printNow = () => {
        const area = document.getElementById("print-area");
        if (!area) return;

        const content = area.innerHTML;
        const printWindow = window.open("", "", "width=800,height=1000");

        printWindow.document.open();
        printWindow.document.write(`
            <html>
                <head>
                    <title>Receipt-${voucherprintid}</title>
                    <style>
                      @page {
                        size: A4;
                        margin: 15mm;
                    }
                        body {
                           font-family: Arial;
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        }
                            .bold{
                               font-weight: bold;
                            }
                        .line {
                            border-top: 1px dashed #000;
                            margin: 5px 0;
                        }
                              .line1 {
                            border-top: 1px dashed #000;
                            margin: 3px 0;
                        }
                        .title {
                            text-align: center;
                            font-size: 20px;
                            text-transform: capitalize;
                            font-weight: bold;
                            margin: 5px 0;
                        }
                             .title_sub { 
                            font-size: 18px;
                            text-transform: capitalize;
                            font-weight: bold;
                            margin: 5px 0;
                        }
                                 .description-text {
                          text-transform: capitalize;
                           
                            margin: 0px 0;
                            font-size: 12px;
                        }
                                  .amount-text {
                          textAlign:right;
text-transform: capitalize;
                            font-weight: 600;
                            margin: 0px 0;
                            font-size: 12px;
                        }
                                .print-container {
                        width: 100%;
                        page-break-inside: avoid;
                    }
 .items-back-fill {
   background-color: #EAEDED;
 padding: 2px 2px;
 }
                    .page-break {
                        page-break-before: always;
                    }
                        table {
                            width: 100%;
                            font-size: 14px;
                               border-collapse: collapse;
                        page-break-inside: avoid;
                        }
                        td {
                            padding: 1px 0;
                        }
                        .info-text {
                            text-align: center;
                            
                            margin: 5px 0;
                            font-size: 13px;
                        }
                        .footer-text {
                            text-align: center;
                            font-weight: bold;
                            margin: 5px 0;
                            font-size: 18px;
                        }
                        .barcode {
                            width: 250px;
                            height: auto;
                            display: block;
                            margin: 1px auto;
                        }
                        .barcode svg {
                            width: 100%;
                            height: 50px;
                        }
                    </style>
                </head>
                <body>
                <div class="print-container">
                    ${content}
                </div>
            </body>
            </html>
        `);
        printWindow.document.close();

        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        };
    };

    if (!voucherdata) return null;
    const domain = new URL(window.location.href).hostname;
    return (
        <div>
            <div
                id="print-area"
                style={{
                    visibility: "hidden",
                    position: "absolute",
                    left: "-9999px",
                }}
            >

                <div className="title">gurudwara haa da naara Sahib</div>
                <div className="info-text">Malerkotla, punjab, india -148023</div>
                <div className="line"></div>

                <table>
                    <tr>
                        <td  >
                            <div className="title_sub">RECEIPT</div>
                        </td>
                        <td width={45}>
                            <QRCode
                                url={domain + "/" + voucherdata.slug}
                                size={40}
                                onReady={() => setReadyToPrint(true)}
                            />
                        </td>

                    </tr>
                </table>

                <div className="line"></div>
                <table>
                    <tr>
                        <td className="bold" width={70}>Token: {voucherdata.tokennumber}</td>
                        <td width={130} style={{ textAlign: "right" }}>
                            {voucherdata.date_time?.toDate ? (
                                <>
                                    {voucherdata.date_time.toDate().toLocaleDateString()}{" "}
                                    {voucherdata.date_time.toDate().toLocaleTimeString()}
                                </>
                            ) : (
                                "No date"
                            )}
                        </td>
                    </tr>
                </table>
                <div className="line"></div>
                <table>
                    <tr>
                        <td>
                            <div className="description-text bold">
                                {voucherdata.namepaying || "Name n/a"}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div className="description-text">
                                {voucherdata.mobile || ""}
                            </div>
                        </td>
                    </tr>
                    <tr>

                        <td>
                            <div className="description-text">
                                {voucherdata.addresspaying || ""}
                            </div>
                        </td>
                    </tr>
                </table>

                <div className="line"></div>
                <table className="description-text">
                    <tbody>
                        {voucheritemsdata.length > 0 ? (
                            voucherdata.items.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.description || item.voucher}</td>
                                    <td>{item.qty}</td>
                                    <td className="amount-text">₹ {item.amount}/-</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td>{voucherdata.voucher}</td>
                                <td className="bold" style={{ textAlign: "right" }}>₹ {voucherdata.amount}/-</td>
                            </tr>
                        )}
                        <tr>
                            <td>
                                {voucherdata.refer_number != null && voucherdata.refer_number !== "" &&
                                    `Refer No.: ${voucherdata.refer_number}`}
                            </td>
                            <td> </td>
                        </tr>
                        <tr>
                            <td >{voucherdata.remarks || voucherdata.description}</td>
                            <td> </td>
                        </tr>
                    </tbody>
                </table>
                <div className="line"></div>
                <table>
                    <tr>
                        <td><b>TOTAL AMOUNT</b></td>
                        <td style={{ textAlign: "right" }}>
                            <b>₹ {voucherdata.totalamount}/-</b>
                        </td>
                    </tr>
                </table>
                  <div className="line"></div>
                <div style={{ textAlign: "right" }}>{AmountToWords(voucherdata.totalamount)}</div>

                {/* <table>
                    <tr>
                        <td><b>CASH</b></td>
                        <td style={{ textAlign: "right" }}>₹ {voucherdata.totalamount}</td>
                    </tr>
                    <tr>
                        <td><b>CHANGE</b></td>
                        <td style={{ textAlign: "right" }}>₹ 0</td>
                    </tr>
                </table> */}


                <div className="footer-text">THANK YOU</div>

                <div className="barcode">
                    <Bar_code value={voucherdata.receiptnumber} />
                </div>

                <div className="info-text bold">Print By: Aooz.in</div>


            </div>
        </div>
    );
}
